<template>
  <common-filter :title="$t('filter.courseFilters')" @confirm="confirmFilter" @cancel="clearFilter">
    <div class="filter-group">
      <label class="filter-label">{{ $t('general.searh') }}:</label>
      <base-reset-button v-if="localPerson.id" v-model="localPerson.id"></base-reset-button>
      <person-search-filter
        :id="localPerson.id"
        :find-by="person.findBy"
        @select:item="selectPerson"
      ></person-search-filter>
    </div>
    <div class="filter-group filter-group-flex">
      <div class="filter-group__part filter-group__part_lg">
        <label class="filter-label">{{ $t('general.date') }}</label>
        <base-reset-button v-if="localDates.startDate" @input="clearDates"></base-reset-button>
        <base-calendar-wrap>
          <range-calendar
            :start-date="localDates.startDate"
            :end-date="localDates.endDate"
            @input="changeDates"
          ></range-calendar>
        </base-calendar-wrap>
      </div>
      <div class="filter-group__part">
        <label class="filter-label">{{ $t('general.id') }}:</label>
        <base-reset-button v-if="localId" v-model="localId"></base-reset-button>
        <id-filter v-model.number="localId"></id-filter>
      </div>
    </div>
    <div class="filter-group">
      <label class="filter-label">{{ $t('courseInfo.courseStatus') }}:</label>
      <base-reset-button v-if="localStatuses.length" v-model="localStatuses"></base-reset-button>
      <status-filter v-model="localStatuses" :status-list="statusList"></status-filter>
    </div>
    <div class="filter-group">
      <label class="filter-label">{{ $t('entity.device') }}:</label>
      <base-reset-button v-if="localDeviceNumber" v-model="localDeviceNumber"></base-reset-button>
      <device-filter :deviceNumber="localDeviceNumber" @input:Number="changeDeviceNumber"></device-filter>
    </div>
  </common-filter>
</template>

<script>
import { courseStatusList } from '@/modules/status-list.js'
import { courseSessionCommon } from '@/components/Filters/mixins/couse-session-common-part.js'

export default {
  name: 'PageCourseFilter',
  mixins: [courseSessionCommon],
  components: {
    DeviceFilter: () => import('@/components/Filters/DeviceFilter.vue')
  },
  props: {
    device: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      localDevice: this.device ? { ...this.device } : null,
      localDeviceNumber: null
    }
  },
  computed: {
    statusList() {
      return courseStatusList
    }
  },
  methods: {
    confirmFilter() {
      this.$emit('confirm', {
        courseId: this.localId,
        person: this.localPerson,
        statuses: this.localStatuses,
        dates: {
          startDate: this.localDates.startDate ? this.moment(this.localDates.startDate) : null,
          endDate: this.localDates.endDate ? this.moment(this.localDates.endDate) : null
        },
        deviceNumber: this.localDeviceNumber,
        device: this.localDeviceNumber ? this.localDevice : null
      })
    },
    clearFilter() {
      this.localPerson = { id: null }
      this.localId = null
      this.localStatuses = []
      this.localDates.startDate = null
      this.localDates.endDate = null
      this.localDevice = null
      this.localDeviceNumber = null
    },
    changeDeviceNumber(devices, number) {
      this.localDevice = devices
      this.localDeviceNumber = number
    }
  }
}
</script>
